





























import {Component, Prop, Vue} from 'vue-property-decorator';

export interface DataItemObj {
    code: string;
    name: string;
    type: string;
    link?: string;
    images: DataImagesObj;
    properties: {
        is_new: boolean,
        is_porcelain: boolean
    };
}

export interface DataImagesObj {
    big: DataImageObj;
    thumbnail: DataImageObj;
    wide: DataImageObj;
    gallery: DataImageObj[];
}

export class DataImageObj {
    public url !: string;
    public alt !: string;
}

@Component({})


export default class MiniTileComp extends Vue {

    @Prop() private dataItem!: DataItemObj;
    @Prop() private tileStyle!: number;
    private randId = Math.random().toString(36).substring(7);

    private switchBigger() {
        this.$emit('switched', this);
    }

    isIos() {
        return (!!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform));
    }

    isAndroid() {
        const userAgent = navigator.userAgent.toLowerCase()
        return (userAgent.indexOf("android") > -1);
    }

    onMiniTileCompClick() {
        if (window.dataLayer) {
            window.dataLayer.push({
                'Category': 'Gallery',
                'Action': `${this.dataItem.code} ${this.dataItem.name}`,
                'Label': 'Regular Picture',
                'event': 'auto_event'
            })
        }
        if (this.dataItem.type.toLowerCase() !== 'filler') {
            this.switchBigger();
        } else if (this.dataItem.link) {
            window.open(this.dataItem.link, '_blank');
        }
    }

    private getBackground() {
        const backgroundUrlForTile = this.tileStyle <= 4 ? (this.dataItem && this.dataItem.images.wide ? this.dataItem.images.wide.url : "") : (this.dataItem && this.dataItem.images.thumbnail ? this.dataItem.images.thumbnail.url : "");
        const backgroundUrlForFiller = this.tileStyle <= 4 ? (this.dataItem && this.dataItem.images.big ? this.dataItem.images.big.url : "") : (this.dataItem && this.dataItem.images.thumbnail ? this.dataItem.images.thumbnail.url : "");

        if (this.dataItem) {
            if (this.dataItem.type === 'Filler') {
                return {'background-image': 'url("' + backgroundUrlForFiller + '")'};
            } else {
                return {'background-image': 'url("' + backgroundUrlForTile + '")'};
            }
        } else {
            return {'background-color': '#444'};
        }
    }

    private get isNew() {
        return this.dataItem && this.dataItem.properties.is_new;
    }

    private get isPorcelain() {
        return this.dataItem && this.dataItem.properties.is_porcelain;
    }

    private mounted() {
        var tileStyle = this.tileStyle < 4 ? 4 : this.tileStyle;
        $("#" + this.randId + ".mini-tile-wrapper").parent().addClass("tile-" + tileStyle);
    }

}
